export interface InputFrame {
  move: { x: number; y: number }
  lookDelta: { x: number; y: number }
  /** Hold: channel defuse под прицелом */
  defuseHold: boolean
  /** Edge: aim-reveal клетки под прицелом (не hold) */
  check: boolean
  pause: boolean
  /** Edge: переключить FPS↔TPP в партии */
  cameraToggle: boolean
}

export const EMPTY_INPUT: InputFrame = {
  move: { x: 0, y: 0 },
  lookDelta: { x: 0, y: 0 },
  defuseHold: false,
  check: false,
  pause: false,
  cameraToggle: false,
}

export interface InputAdapter {
  sample(dt: number): InputFrame
  setEnabled(enabled: boolean): void
  dispose(): void
}
